import { IGetters } from './getters.types';
import { ICommunicationData } from '@/entities';
import { AppConstants as _app } from '@/shared/app.constants';
import { Utilities as _utils } from '@/shared/utilities';

export const getters: IGetters = {
    sections(state: ICommunicationData) {
        var sections = {
            "summary": {
                "title": "Summary",
                "x-class": "logical-framework"
            }
        };
        if (state.reports.length > 0) {
            sections = state.reports.reduce((x, y) => {
                
                if(y && y.StepId) 
                    x[y.StepId] = Object.assign(y.StepId?{ "x-class": `${y.StepId}` }:{ "x-class": "logical-framework" }, { title: y.Description });
                
                return x;
            }, sections)
        }
        return Object.assign({}, {"properties": sections});
    },
    statusText: (state: ICommunicationData) => (stepId: number, isReturned: number) => {
        const step = state.workflowSteps.find(x => x.ID == stepId);
        if(step) {
            return (isReturned)? step.ReturnStatus || step.Status : step.Status;
        } else {
            return 'Not Started';
        }
    }
}